import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-bg text-fg">
            <Header />
            <main className="flex-1 w-full">{children}</main>
            <Footer />
        </div>
    );
}
